import { useQuery } from "react-query";
import { getOfficeHierarchies } from "../../../../actions/OfficeHierarchy";

export const useOfficeHierarchy = () => {
  return useQuery("GetOfficeHierarchy", getOfficeHierarchies, {
    refetchOnWindowFocus: false,
  });
};
